import React from 'react';
import { ExtraFieldsError } from '../ExtraFieldsError';
import ExtraFieldsErrorBoundary from '../ExtraFieldsErrorBoundary';
import {
  ExtraFieldContextParam,
  ExtraFieldsFormIds,
  ExtraFieldsSupportedObject,
} from '../types';
import { useObjectExtraFields } from '../useObjectExtraFields';
import { ExtraFieldsAreaContent7, Loading7 } from './ExtraFieldsAreaContent7';

export type Props = {
  objectApiName: ExtraFieldsSupportedObject;
  formId: ExtraFieldsFormIds;
  contextParams?: ExtraFieldContextParam[];
  disabled?: boolean;
  hideRecordType?: boolean;
  hideEmptyLookups?: boolean;
};

export const ExtraFieldsArea7: React.FC<React.PropsWithChildren<Props>> = ({
  objectApiName,
  formId,
  contextParams,
  disabled,
  hideRecordType = false,
  hideEmptyLookups = false,
}) => {
  const { rawObjectExtraFields, getFormFields, loading, error } =
    useObjectExtraFields(objectApiName);

  const formFields = getFormFields(formId);

  if (loading) {
    return <Loading7 />;
  }
  if (error) {
    return <ExtraFieldsError error={`Server error: ${error.message}`} />;
  }
  if (!rawObjectExtraFields) {
    return null;
  }
  const { availableRecordTypes } = rawObjectExtraFields;
  return (
    <ExtraFieldsErrorBoundary>
      <ExtraFieldsAreaContent7
        contextParams={contextParams}
        availableRecordTypes={availableRecordTypes}
        formFields={formFields}
        disabled={disabled}
        hideRecordType={hideRecordType}
        hideEmptyLookups={hideEmptyLookups}
      />
    </ExtraFieldsErrorBoundary>
  );
};
